import { Switch } from '@syncfusion/ej2-buttons';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { DropDownList, MultiSelect } from '@syncfusion/ej2-dropdowns';
import { TextBox } from '@syncfusion/ej2-inputs';
import { RichTextEditor } from '@syncfusion/ej2-richtexteditor';

import { EditableClientProps } from '@/shared/types/editable';
import { DEFAULT_LOCALE } from '@/shared/utils/format';

const DEFAULT_WIDTH = 200;

export type Control = TextBox | RichTextEditor | DropDownList | MultiSelect | DatePicker | Switch;

export type ControlValue =
  | string
  | string[]
  | number
  | number[]
  | boolean
  | boolean[]
  | Date
  | object
  | null
  | undefined;

export const controlModel = (p: EditableClientProps) => ({
  locale: DEFAULT_LOCALE.code,
  value: p.value,
  readonly: p.readOnly,
  format: p.format,
  autocomplete: 'off',
  placeholder: p.placeholder,
  ...(!p.fullwidth ? { width: p.width ?? DEFAULT_WIDTH } : {}),
  height: p.height,
});

export const isSwitch = (control: Control): control is Switch => {
  return 'checked' in control;
};
